import { get } from 'env-var';
import logger from '3-foundation/Logging/logger';

let WEBSITE_SSG_URL: string;
let ROBOTS_TXT_DISALLOW_ALL: boolean;
let LOG_TO_DISK: boolean;
let NEXT_PUBLIC_SITENAME: string;
let NEXT_PUBLIC_LOG_TO_CONSOLE: boolean;
let NODE_ENV: string;
let SEARCH_API_URL: string;
let ISR_CACHE_SECRET: string;
let LOG_LEVEL: string;
let CONTENT_API_URL: string;
let CDA_KEY: string;

// Only perform assignment and check serverside / at build time
if (typeof window === 'undefined') {
	// Read variables using env-var API
	WEBSITE_SSG_URL = get('WEBSITE_SSG_URL').required().asUrlString();
	ROBOTS_TXT_DISALLOW_ALL = get('ROBOTS_TXT_DISALLOW_ALL').default('false').asBool();
	LOG_TO_DISK = get('LOG_TO_DISK').required().asBoolStrict();
	NEXT_PUBLIC_SITENAME = get('NEXT_PUBLIC_SITENAME').required().asString();
	NEXT_PUBLIC_LOG_TO_CONSOLE = get('NEXT_PUBLIC_LOG_TO_CONSOLE').required().asBoolStrict();
	NODE_ENV = get('NODE_ENV').required().asString();
	SEARCH_API_URL = get('SEARCH_API_URL').required().asString();
	ISR_CACHE_SECRET = get('ISR_CACHE_SECRET').required().asString();
	LOG_LEVEL = get('LOG_LEVEL').required().asString();
	CONTENT_API_URL = get('CONTENT_API_URL').required().asUrlString();
	CDA_KEY = get('CDA_KEY').required().asString();
} else {
	try {
		// Force NextJs to bake in public vars client side using direct reference to process.env
		// https://github.com/evanshortiss/env-var/issues/162
		NEXT_PUBLIC_LOG_TO_CONSOLE = Boolean(process.env.NEXT_PUBLIC_LOG_TO_CONSOLE);

		NODE_ENV = process.env.NODE_ENV;
		if (typeof NODE_ENV === 'undefined') {
			logger.error('Reference error - NODE_ENV is undefined');
			throw new Error(`NODE_ENV is undefined`);
		}
	} catch (e) {
		logger.error(e);
	}
}

export {
	WEBSITE_SSG_URL,
	LOG_TO_DISK,
	NEXT_PUBLIC_SITENAME,
	NEXT_PUBLIC_LOG_TO_CONSOLE,
	NODE_ENV,
	ROBOTS_TXT_DISALLOW_ALL,
	SEARCH_API_URL,
	ISR_CACHE_SECRET,
	LOG_LEVEL,
	CONTENT_API_URL,
	CDA_KEY,
};
